import { Button, type ButtonType } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

type Props = {
    className?: string;
    type?: ButtonType;
    dataAutomation: string;
    isDisabled: boolean;
    isLoading?: boolean;
    onClick: VoidFunction;
};

const UpdateSearchButton = ({
    className,
    type = "flat",
    dataAutomation,
    isDisabled,
    isLoading = false,
    onClick,
}: Props) => {
    return (
        <Button
            className={className}
            dataAutomation={dataAutomation}
            type={type}
            isDisabled={isDisabled}
            isLoading={isLoading}
            onClick={onClick}
        >
            {translate("si.lead_gen_filters.button.update_current")}
        </Button>
    );
};

export default UpdateSearchButton;
